(() => {
  function init(scope) {
    scope.querySelectorAll('[data-saam-pdp-rating]').forEach(badge => {
      if (badge.dataset.initialized) return;
      const target = document.querySelector('[data-saam-extension-product]') || document.getElementById(badge.hash.slice(1));
      if (!target) return;
      badge.href = '#' + target.id;
      badge.dataset.initialized = 'true';
      // Keep one rating preview linked to the active review section.
      const info = badge.closest('.product__info-container');
      info?.querySelectorAll(':scope > .shopify-app-block > .jdgm-preview-badge').forEach(preview => {
        preview.parentElement.hidden = true;
        preview.parentElement.style.setProperty('display', 'none', 'important');
      });
      badge.addEventListener('click', event => {
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
